import type { VehicleId } from '../types/gcs/vehicle';

export function serializeGcsVehicleId(gcsId: string, vehicleId: VehicleId): string {
  return `${gcsId}|${vehicleId}`;
}

export function deserializeGcsVehicleId(jointId: string): { gcsId: string; vehicleId: VehicleId } {
  const [gcsId, vehicleIdStr] = jointId.split('|');
  return { gcsId, vehicleId: Number(vehicleIdStr) as VehicleId };
}
